"use client"

import { useEffect, useState } from "react"
import { observer } from "mobx-react-lite"
import { Plus } from "lucide-react"
import MODAL_NAMES from "../../../dialogs/ModalName"
import { useAppContext } from "../../../../shared/functions/Context"
import showModalFromId from "../../../../shared/functions/ModalShow"
import NewValueModal from "../modals/CreateValueModal"
import Modal from "../../../../shared/components/Modal"
import { CriteriaBox } from "../components/CriteriaBox"
import EditValueModal from "../modals/EditValueModal"

const ValuesView = observer(() => {
  const { api, store } = useAppContext()
  const [loading, setLoading] = useState(true)

  const addNewValue = () => {
    showModalFromId(MODAL_NAMES.THREE_SIXTY_FEEDBACK.CREATE_VALUE_MODAL)
  }

  const values = store.value.all.map((value) => value.asJson)

  useEffect(() => {
    const load = async () => {
      try {
        await api.value.getAll()
      } catch (error) {
        console.error("Failed to fetch values:", error)
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [api.value])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64 w-full">
        <div className="relative">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-200"></div>
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-600 border-t-transparent absolute top-0 left-0"></div>
        </div>
      </div>
    )
  }

  return (
    <div className="w-full space-y-6">
      {/* Header Section */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 p-6 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl border border-blue-100">
        <div>
          <h2 className="text-2xl font-bold text-slate-800 mb-2">Company Values</h2>
          <p className="text-slate-600">Manage and organize your organization's core values</p>
        </div>
        <button
          onClick={addNewValue}
          className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
        >
          <Plus className="h-5 w-5" />
          Create Value
        </button>
      </div>

      {/* Content Section */}
      {values.length > 0 ? (
        <CriteriaBox value={values} />
      ) : (
        <div className="text-center py-16 bg-white rounded-2xl border border-slate-200 shadow-sm">
          <div className="max-w-md mx-auto">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <Plus className="h-8 w-8 text-blue-600" />
            </div>
            <h3 className="text-xl font-semibold text-slate-800 mb-2">No Values Available</h3>
            <p className="text-slate-600 mb-6">
              Create your first company value to get started with the evaluation process.
            </p>
            <button
              onClick={addNewValue}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-semibold px-6 py-3 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <Plus className="h-5 w-5" />
              Create Your First Value
            </button>
          </div>
        </div>
      )}

      {/* Modals */}
      <Modal modalId={MODAL_NAMES.THREE_SIXTY_FEEDBACK.CREATE_VALUE_MODAL}>
        <NewValueModal />
      </Modal>
      <Modal modalId={MODAL_NAMES.THREE_SIXTY_FEEDBACK.EDIT_VALUE_MODAL}>
        <EditValueModal />
      </Modal>
    </div>
  )
})

export default ValuesView
